// ══════════════════════════════════════════════════════════════════════
//  BREAKING THE CYCLE — CHILD BASELINE FORM
//  Fomu rasmi ya taasisi kwa watoto wa programu ya Msaada. Imenakiliwa
//  kwa uaminifu kutoka "Breaking the Cycle - Child Baseline Form.docx"
//  iliyopitishwa na taasisi. Kila sehemu (A–D) inajazwa na mtu tofauti
//  (Mwalimu, Kocha, Mwalimu wa ziada, Mratibu) kwa nyakati tofauti —
//  ndiyo maana kila sehemu inahifadhiwa (kusaveiwa) KIVYAKE, bila
//  kuhitaji mtu mmoja kumaliza fomu nzima kwa kukaa kimoja.
// ══════════════════════════════════════════════════════════════════════

export const FORM_TYPES = [
  { key: 'baseline', label: 'Baseline (Taarifa za Awali)' },
  { key: 'endline', label: 'Endline (Taarifa za Mwisho)' },
];

// ── Header — sehemu ya juu ya fomu (si ya sehemu A–D) ──────────────────
export const BASELINE_HEADER_FIELDS = [
  { key: 'childNo', label: 'Namba ya mtoto (Child No.)', enLabel: 'Child No.', type: 'text',
    hint: 'Tumia namba hii, si jina, kwenye nakala yoyote inayotoka ofisini.' },
  { key: 'dateFilled', label: 'Tarehe', enLabel: 'Date', type: 'date' },
  { key: 'termUsed', label: 'Muhula uliotumika kwa data', enLabel: 'Term used for data', type: 'text',
    placeholder: 'mf. Muhula 2, 2026' },
];

// ── Sehemu A–D ──────────────────────────────────────────────────────────
export const BASELINE_SECTIONS = [
  {
    id: 'A',
    title: 'A. Kumbukumbu za Shule',
    enTitle: 'School Records',
    completerLabel: 'Mwalimu wa darasa',
    enCompleter: 'Class teacher',
    color: '#14452F',
    icon: 'report',
    fields: [
      { key: 'a1_attendance', label: 'A1. Siku alizohudhuria muhula uliopita / siku shule ilifunguliwa',
        enLabel: 'Days present last term / days school was open', type: 'text', placeholder: 'mf. 72 / 90' },
      { key: 'a2_examMarks', label: 'A2. Mtihani wa muhula uliopita — jumla ya alama', enLabel: 'Total exam marks', type: 'number' },
      { key: 'a2_examOutOf', label: 'A2. Alama kati ya (out of)', enLabel: 'Marks out of', type: 'number' },
      { key: 'a2_position', label: 'A2. Nafasi darasani', enLabel: 'Position in class', type: 'number' },
      { key: 'a2_positionOutOf', label: 'A2. Nafasi kati ya wanafunzi wangapi', enLabel: 'Position out of', type: 'number' },
      { key: 'a3_kiswahili', label: 'A3. Alama ya Kiswahili', enLabel: 'Kiswahili mark', type: 'number' },
      { key: 'a3_english', label: 'A3. Alama ya Kiingereza', enLabel: 'English mark', type: 'number' },
      { key: 'a3_maths', label: 'A3. Alama ya Hisabati', enLabel: 'Mathematics mark', type: 'number' },
      { key: 'a4_repeated', label: 'A4. Je, mtoto amewahi kurudia darasa?', enLabel: 'Has the child repeated a class?',
        type: 'select', options: ['Hapana', 'Ndiyo'] },
      { key: 'a4_repeatedWhich', label: 'A4. Kama Ndiyo — darasa gani', enLabel: 'If yes, which class', type: 'text' },
      { key: 'a5_teacherView', label: "A5. Maoni ya mwalimu: darasani mtoto", enLabel: 'Teacher’s view', type: 'select',
        options: ['Anaendana na wenzake (Keeping up)', 'Yuko nyuma kidogo (Slightly behind)', 'Yuko nyuma sana (Far behind)'] },
    ],
  },
  {
    id: 'B',
    title: 'B. Mahitaji na Ushiriki',
    enTitle: 'Material Needs & Participation',
    completerLabel: 'Kocha (siku 2 za kwanza)',
    enCompleter: 'Coach, observed at first 2 sessions',
    color: '#E07A2E',
    icon: 'chess',
    fields: [
      { key: 'b1_uniform', label: 'B1. Sare ya shule', enLabel: 'Uniform', type: 'select',
        options: ['Kamili (Complete)', 'Haikamiliki / imechakaa', 'Hana kabisa'] },
      { key: 'b2_shoes', label: 'B2. Viatu', enLabel: 'Shoes', type: 'select',
        options: ['Ana viatu vya shule', 'Ana sandalo / vingine', 'Hana kabisa'] },
      { key: 'b3_books', label: 'B3. Madaftari na kalamu', enLabel: 'Exercise books and pen/pencil', type: 'select',
        options: ['Ana vyote', 'Ana baadhi', 'Hana kabisa'] },
      { key: 'b4_day1', label: 'B4. Alikula kabla ya kuja shule — Siku ya 1', enLabel: 'Ate before school — Day 1', type: 'select',
        options: ['Ndiyo', 'Hapana'] },
      { key: 'b4_day2', label: 'B4. Alikula kabla ya kuja shule — Siku ya 2', enLabel: 'Ate before school — Day 2', type: 'select',
        options: ['Ndiyo', 'Hapana'] },
      { key: 'b5_eatsAtSchool', label: 'B5. Anakula shuleni mchana?', enLabel: 'Eats at school during the day', type: 'select',
        options: ['Chakula cha shule', 'Analeta chakula', 'Ananunua', 'Hakuna kabisa'] },
      { key: 'b6_pastActivity', label: 'B6. Amewahi kushiriki mchezo, klabu au shughuli nje ya darasa?', enLabel: 'Past sport/club/activity', type: 'select',
        options: ['Hapana', 'Ndiyo'] },
      { key: 'b6_pastActivityWhat', label: 'B6. Kama Ndiyo — ni shughuli gani', enLabel: 'If yes, what', type: 'text' },
      { key: 'b7_chessBefore', label: 'B7. Amewahi kucheza chess?', enLabel: 'Has played chess before', type: 'select',
        options: ['Kamwe', 'Kidogo', 'Anajua mchezo'] },
    ],
  },
  {
    id: 'C',
    title: 'C. Upimaji wa Kujifunza',
    enTitle: 'Learning Check',
    completerLabel: 'Mwalimu wa ziada (dakika 10 na mtoto)',
    enCompleter: 'Tutor, 10 minutes with the child',
    color: '#7C3AED',
    icon: 'sparkle',
    fields: [
      { key: 'c1_kiswahiliReading', label: 'C1. Anasoma kifungu cha Kiswahili cha darasa lake kwa sauti', enLabel: 'Reads Kiswahili passage aloud', type: 'select',
        options: ['Fasaha (Fluent)', 'Pole pole / na makosa', 'Maneno pekee', 'Hawezi kusoma'] },
      { key: 'c2_englishReading', label: 'C2. Anasoma sentensi rahisi ya Kiingereza', enLabel: 'Reads simple English sentence', type: 'select',
        options: ['Ndiyo', 'Kiasi', 'Hapana'] },
      { key: 'c3_arithmetic', label: 'C3. Hesabu kumi za darasa lake — zilizo sahihi (kati ya 10)', enLabel: 'Arithmetic — correct out of 10', type: 'number', min: 0, max: 10 },
      { key: 'c4_writing', label: 'C4. Anaandika jina lake na sentensi aliyoambiwa', enLabel: 'Writes own name and dictated sentence', type: 'select',
        options: ['Vyote viwili', 'Jina tu', 'Hakuna'] },
      { key: 'c5_tutorRating', label: 'C5. Tathmini ya jumla ikilinganishwa na darasa lake', enLabel: 'Tutor’s overall rating vs class level', type: 'select',
        options: ['Sawa na darasa (At level)', 'Chini kidogo (Below level)', 'Chini sana (Far below level)'] },
    ],
  },
  {
    id: 'D',
    title: 'D. Nyumbani na Familia',
    enTitle: 'Home & Family',
    completerLabel: 'Mratibu (mazungumzo na mzazi/mlezi)',
    enCompleter: 'Coordinator, conversation with parent/guardian',
    color: '#1D4ED8',
    icon: 'heart',
    fields: [
      { key: 'd1_livesWith', label: 'D1. Mtoto anaishi na', enLabel: 'Child lives with', type: 'select',
        options: ['Wazazi wote wawili', 'Mama', 'Baba', 'Babu/Bibi', 'Ndugu mwingine'] },
      { key: 'd2_childrenCount', label: 'D2. Idadi ya watoto nyumbani', enLabel: 'Number of children in household', type: 'number' },
      { key: 'd3_incomeSource', label: 'D3. Chanzo kikuu cha kipato', enLabel: 'Main source of household income', type: 'select',
        options: ['Vibarua (Casual labour)', 'Biashara ndogo', 'Kilimo', 'Mshahara', 'Hakuna'] },
      { key: 'd4_incomeRegularity', label: 'D4. Kipato hicho kinapatikana mara ngapi?', enLabel: 'How regular is that income', type: 'select',
        options: ['Kila siku / kila wiki', 'Si mara kwa mara', 'Nadra sana'] },
      { key: 'd5_parentEducation', label: 'D5. Elimu ya mzazi/mlezi', enLabel: 'Parent/guardian education', type: 'select',
        options: ['Hajasoma kabisa', 'Msingi — baadhi', 'Msingi — amemaliza', 'Sekondari au zaidi'] },
      { key: 'd6_vicoba', label: 'D6. Mzazi amewahi kuwa kwenye kikundi cha kuweka akiba (VICOBA)?', enLabel: 'Parent ever in a savings group (VICOBA)', type: 'select',
        options: ['Kamwe', 'Hapo awali', 'Ni mwanachama sasa'] },
      { key: 'd7_business', label: 'D7. Mzazi anafanya biashara yoyote ndogo sasa?', enLabel: 'Parent runs small business now', type: 'select',
        options: ['Hapana', 'Ndiyo'] },
      { key: 'd7_businessWhat', label: 'D7. Kama Ndiyo — biashara gani', enLabel: 'If yes, what', type: 'text' },
      { key: 'd8_difficulty', label: "D8. Ugumu mkubwa wa kumweka mtoto shuleni (maneno ya mzazi)", enLabel: 'Biggest difficulty (parent’s own words)',
        type: 'textarea', rows: 3 },
    ],
  },
];

// ── Usajili wa kukamilika — asilimia ya sehemu/jumla ya fomu ───────────
export function sectionCompletion(values, section) {
  const vals = values || {};
  const total = section.fields.length;
  if (!total) return 0;
  const done = section.fields.filter(f => {
    const v = vals[f.key];
    return v !== undefined && v !== null && v !== '';
  }).length;
  return Math.round((done / total) * 100);
}

export function overallCompletion(values) {
  const allFields = BASELINE_SECTIONS.flatMap(s => s.fields);
  if (!allFields.length) return 0;
  const vals = values || {};
  const done = allFields.filter(f => {
    const v = vals[f.key];
    return v !== undefined && v !== null && v !== '';
  }).length;
  return Math.round((done / allFields.length) * 100);
}
